export const DEFAULT_AMF_TASK_CARD_CONFIGURATION = {
  process_information_area: ['des', 'sid'],
  associated_users_list: ['organization_executor', 'organization_requester'],
  timestamps_area: ['date_creation_row', 'date_start_row']
} as const
